import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";
import ModalImage from "react-modal-image";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getCivilAccount, resetCivilAccountState } from "../../../store/civilAccount/action";
import { getProductBlock } from "../../../store/productBlock/action";
import { resetProductState, getProduct } from "../../../store/product/action";
import { getCivilOpname as onGetCivilOpnames, addNewCivilOpname as onAddNewCivilOpname, updateCivilOpname as onUpdateCivilOpname, deleteCivilOpname as onDeleteCivilOpname, getCivilOpnameLoading, resetCivilOpnameState } from "../../../store/civilOpname/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import defaultImg from "../../../assets/images/logo-sm.png";
import { api } from "../../../config";

import ExportDoc from "../../../Components/Common/ExportDoc";

const CivilOpname = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [logo, setLogo] = useState(defaultImg);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, productBlocks, productBlockLoading, products, productLoading, civilAccounts, civilAccountLoading, clients, clientLoading, branches, branchLoading, loading, error, civilOpnames, isCivilOpnameCreated, isCivilOpnameSuccess, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    civilOpnames: state.CivilOpname.civilOpnames,
    isCivilOpnameCreated: state.CivilOpname.isCivilOpnameCreated,
    isCivilOpnameSuccess: state.CivilOpname.isCivilOpnameSuccess,
    loading: state.CivilOpname.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    productBlocks: state.ProductBlock.productBlocks,
    productBlockLoading: state.ProductBlock.loading,
    products: state.Product.products,
    productLoading: state.ProductBlock.loading,
    error: state.CivilOpname.error,
    civilAccounts: state.CivilAccount.civilAccounts,
    civilAccountLoading: state.CivilAccount.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [civilOpnameList, setCivilOpnameList] = useState([]);
  const [civilOpname, setCivilOpname] = useState([]);
  const [componentDetailAddedId, setComponentDetailAddedId] = useState(0);
  const [info, setInfo] = useState(null);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [blockList, setBlockList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [dataRAB, setDataRAB] = useState({});
  const [civilOpnamesDoc, setCivilOpnamesDoc] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const typeSelectData = [
    {
      options: [
        { label: "INFRASTRUKTUR", value: "INFRASTRUKTUR" },
        { label: "BANGUNAN", value: "BANGUNAN" },
        { label: "UPAH", value: "UPAH" },
        { label: "PROGRESS BANGUNAN", value: "PROGRESS BANGUNAN" },
      ],
    },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [searchValue, setSearchValue] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");
  const [searchBlock, setSearchBlock] = useState("");

  const onClickDelete = (civilOpname) => {
    setCivilOpname(civilOpname);
    setDeleteModal(true);
  };

  const handleDeleteCivilOpname = () => {
    if (civilOpname) {
      setComponentDetailAddedId(civilOpname.componentId);
      dispatch(onDeleteCivilOpname(civilOpname));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (data) => {
    setCivilOpname(data);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredCivilOpnames = civilOpnames;
      if (type !== "all") {
        filteredCivilOpnames = civilOpnames.filter((civilOpname) => civilOpname.cvlop_status.name === type);
      }
      setCivilOpnameList(filteredCivilOpnames);
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      setDataRAB({});
      setInfo({});
      setCivilOpnameList([]);
      handleGetCivilOpname(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  const handleGetCivilOpname = (id, branchId) => {
    dispatch(resetCivilOpnameState());
    dispatch(onGetCivilOpnames({ companyId: id, branchId: branchId }));
    handleGetProductBlock(id);
  };

  const handleGetProductBlock = (companyId) => {
    dispatch(getProductBlock({ companyId: companyId }));
  };

  const handleGetProduct = (branchId, blockId) => {
    dispatch(resetProductState());
    dispatch(getProduct({ branchId: branchId, blockId: blockId, type: "1" }));
  };

  const handleGetCivilAccount = (companyId, branchId) => {
    dispatch(resetCivilAccountState());
    dispatch(getCivilAccount({ companyId: companyId, branchId: branchId, type: "upah" }));
  };

  useEffect(() => {
    if (!isEmpty(civilOpnames)) {
      setIsEdit(false);
      let filteredCivilOpnames = civilOpnames;
      if (activeTypeTab !== "all") {
        filteredCivilOpnames = civilOpnames.filter((civilOpname) => civilOpname.cvlop_status.name === activeTypeTab);
      }
      setCivilOpnameList(filteredCivilOpnames.map((el) => ({ ...el, isChecked: false })));
      let current = 0;
      if (componentDetailAddedId !== 0) {
        civilOpnames.forEach((obj, i) => {
          if (obj.id === componentDetailAddedId) current = i;
        });
      }
      setInfo(civilOpnames[current]);
      handleGetCivilAccount(civilOpnames[current].companyId, civilOpnames[current].branchId);
    }
    else
    {
      setCivilOpnameList([]);
    }
  }, [civilOpnames, componentDetailAddedId]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "cvlop_branch",
        label: "Proyek",
        isSelected: true,
        data: [],
      },
    ];

    if (civilOpnameList.length > 0) {
      civilOpnameList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "cvlop_branch") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "cvlop_product") {
                const name = dataDoc.find((d) => d.id === "name");
                const blok_name = data?.cvlop_product?.product_block?.name ?? "";
                const nameData = `${blok_name} - ${data.cvlop_product?.name ?? "-"} - ${data?.cvlop_product?.product_category?.name} - ${data?.cvlop_product?.product_block?.name}`;
                name.data.push(nameData);
              }
            }
          });
        }
      });
    }

    setCivilOpnamesDoc(dataDoc);
  }, [civilOpnameList]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);
    setCompanyList(data);
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id, companyId: item.companyId };
      opt.push(obj);
    });
    var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);
    setBranchList(data);
  }, [branches]);

  const toggleBlock = (val) => {
    setSearchValue("");
    dispatch(onGetCivilOpnames({ companyId: companySelected?.value ?? "", block: val, branchId: branchSelected.value }));
  };

  useEffect(() => {
    var data = [];
    var opt = [{ label: "Semua Block", value: "" }];
    productBlocks.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);
    setBlockList(data);
  }, [productBlocks]);

  useEffect(() => {
    var data = [];
    var opt = [];
    products.forEach((item, key) => {
      const category = item.product_category?.name ?? "No Set";
      const block = item.product_block?.name ?? "No Set";
      const name = item.name;
      const id = item.id;
      var obj = { label: `${category} - ${block} - ${name}`, value: id };
      if (item?.statusId === 1 || item?.statusId === 2)
        opt.push(obj);
    });
    var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);
    setProductList(data);
  }, [products]);

  useEffect(() => {
    if (civilAccounts.length > 0) {
      const progresCheckList = info?.checked_progress?.toString().split(",") || [];
      let dataRAB = {};

      for (const civilDetail of civilAccounts) {
        const categoryName = civilDetail.cvl_account_category ? civilDetail.cvl_account_category.name : "";

        const item = {
          id: civilDetail.id,
          name: civilDetail.name,
          sort_order: civilDetail.sort_order,
          isSelected: progresCheckList.includes(civilDetail?.id?.toString()),
          //isDisabled: progresCheckList.includes(civilDetail?.cvld_account?.id?.toString())
        };

        if (!dataRAB[categoryName]) {
          dataRAB[categoryName] = [];
        }

        dataRAB[categoryName].push(item);
      }
      for (const category in dataRAB) {
        dataRAB[category].sort((a, b) => a.sort_order - b.sort_order);
      }
      const sortedCategories = Object.entries(dataRAB)
        .map(([category, items]) => ({
          category,
          items,
          minsort_order: Math.min(...items.map((item) => item.sort_order)),
        }))
        .sort((a, b) => a.minsort_order - b.minsort_order);
      const sortedDataRAB = sortedCategories.reduce((acc, { category, items }) => {
        acc[category] = items;
        return acc;
      }, {});

      setDataRAB(sortedDataRAB);
    }
  }, [civilAccounts]);

  const [filterDate, setFilterDate] = useState(null);
  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCivilOpname(null);
      setProductList([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal, dispatch]);

  const handleCivilOpnameClick = useCallback(
    (arg) => {
      const data = arg;
      handleGetProduct(data.branchId, data?.cvlop_product?.product_block?.id);
      setCivilOpname({
        id: data.id,
        client: data.cvlop_client && {
          label: data.cvlop_client ? data.cvlop_client.name : "",
          value: data.cvlop_client ? data.cvlop_client.id : "",
        },
        company: data.cvlop_company && {
          label: data.cvlop_company ? data.cvlop_company.name : "",
          value: data.cvlop_company ? data.cvlop_company.id : "",
        },
        branch: data.cvlop_branch && {
          label: data.cvlop_branch ? data.cvlop_branch.name : "",
          value: data.cvlop_branch ? data.cvlop_branch.id : "",
        },
        block: data.cvlop_product &&
          data.cvlop_product.product_block && {
          label: data?.cvlop_product?.product_block?.name,
          value: data?.cvlop_product?.product_block?.id,
        },
        product: data.cvlop_product && {
          label: `${data?.cvlop_product?.product_category?.name ?? "No Set"} - ${data?.cvlop_product?.product_block?.name ?? "No Set"} - ${data?.cvlop_product?.name}`,
          value: data?.cvlop_product?.id,
        },
        checked_progress: data.checked_progress,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = civilOpnameList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setCivilOpnameList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = civilOpnameList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setCivilOpnameList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      handleGetCivilAccount(data.companyId, data.branchId);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateCivilOpname") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleCivilOpnameClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteCivilOpname") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : userRole && userRole.split(",").indexOf("approveCivilOpname") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : "btn-label btn btn-sm btn-soft-success fs-12 ms-1 d-none"}
                  onClick={() => {
                    setInfo(data);
                    onClickApprove();
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        id: "Nama",
        Header: "Nama",
        accessor: (data) => `${data?.cvlop_product?.product_block?.name} ${data?.cvlop_product?.name}`,
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          let blok_name = data?.cvlop_product?.product_block?.name ?? "";
          let statusData = "";
          switch (data?.cvlop_status?.name) {
            case "DRAFT":
              statusData = <span className="badge text-uppercase badge-soft-warning">{data?.cvlop_status?.name}</span>;
              break;
            case "ACTIVE":
              statusData = <span className="badge text-uppercase badge-soft-info">{data?.cvlop_status?.name}</span>;
              break;
            case "INACTIVE":
              statusData = <span className="badge text-uppercase badge-soft-danger">{data?.cvlop_status?.name}</span>;
              break;
            default:
              statusData = <span className="badge text-uppercase badge-soft-warning">{data?.cvlop_status?.name}</span>;
              break;
          }
          return (
            <div
              className="d-flex align-items-center cursor-pointer"
              onClick={() => {
                setInfo(data);
                handleGetCivilAccount(data.companyId, data.branchId);
              }}
            >
              <div className="flex-shrink-0 me-3">
                <div className="avatar-md bg-light rounded p-1">{<img src={data?.cvlop_product?.image === "" ? logo : `${api.MEDIA_URL}/media/${data?.cvlop_product?.image}-w-150`} alt="" className="img-fluid d-block" />}</div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {blok_name} - {data?.cvlop_product?.name}
                </h5>
                <p className="text-muted mb-0">
                  {data?.cvlop_product?.product_category?.name} {data?.cvlop_product?.product_block?.name}
                </p>
                <p>
                  {statusData} - {handleValidDate(data.createdat)}
                </p>
              </div>
            </div>
          );
        },
      },
      {
        id: "Branch",
        Header: "Proyek",
        accessor: "cvlop_branch.name",
        filterable: true,
      },
    ],
    [civilOpnameList, handleCivilOpnameClick, userType, userRole, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = civilOpnameList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setCivilOpnameList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => civilOpnameList, [civilOpnameList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;

  const handleApproveComponent = () => {
    if (info) {
      info.setApprove = true;
      info.statusId = 2;
      dispatch(onUpdateCivilOpname(info));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      company: (civilOpname && civilOpname.company) || companySelected,
      client: (civilOpname && civilOpname.client) || clientSelected,
      branch: (civilOpname && civilOpname.branch) ?? "",
      block: (civilOpname && civilOpname.block) ?? "",
      product: (civilOpname && civilOpname.product) ?? "",
      checked_progress: (civilOpname && civilOpname.checked_progress) || "no",
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Please Enter company").nullable(true),
      client: Yup.object().required("Please Enter client").nullable(true),
      branch: Yup.object().required("Please Enter Proyek / Cabang").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateCivilOpname = {
          id: civilOpname ? civilOpname.id : 0,
          clientId: values.client.value,
          companyId: values.company.value,
          branchId: values.branch.value,
          blockId: values.block.value,
          productId: values.product.value,
          description: "",
          files: [],
          checked_progress: values.checked_progress,
        };
        dispatch(getCivilOpnameLoading());
        dispatch(onUpdateCivilOpname(updateCivilOpname));
        validation.resetForm();
      } else {
        const findProduct = civilOpnames.find((d) => d.productId === values.product.value);
        if (!findProduct) {
          dispatch(getCivilOpnameLoading());
          const newCivilOpname = {
            clientId: values.client.value,
            companyId: values.company.value,
            branchId: values.branch.value,
            blockId: values.block.value,
            productId: values.product.value,
            description: "",
            files: [],
            checked_progress: "no",
          };
          dispatch(onAddNewCivilOpname(newCivilOpname));
        } else {
          toast.success("Unit Sudah Pernah Ditambahkan", { autoClose: 3000 });
        }
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: (civilOpname && civilOpname.description) ?? "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      const cps = [];
      if (Object.keys(dataRAB).length > 0) {
        Object.values(dataRAB).forEach((category) => {
          category.forEach((itemRab) => {
            if (itemRab.isSelected) {
              cps.push(itemRab.id);
            }
          });
        });
      }

      const updateCivilOpname = {
        id: info.id,
        clientId: info.clientId,
        companyId: info.companyId,
        branchId: info.branchId,
        blockId: info.cvlop_product?.product_block?.id,
        productId: info.cvlop_product?.id,
        description: values.description,
        files: [],
        checked_progress: cps.length > 0 ? cps.join(",") : "no",
      };
      dispatch(onUpdateCivilOpname(updateCivilOpname));
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilOpname(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      status: status,
      block: searchBlock?.value ?? "",
      branchId: branchSelected?.value ?? "",
    };

    dispatch(resetCivilOpnameState());
    setCivilOpnameList([]);
    dispatch(onGetCivilOpnames(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setCivilOpnameList([]);
    setSearchValue("");
    setSearchBlock("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");

    handleGetCivilOpname(companySelected?.value ?? "", branchSelected?.value ?? "");
  }

  const approveFinalMultiple = () => {
    for (const item of civilOpnameList || []) {
      if (item.isChecked) {
        const cps = [];
        if (Object.keys(dataRAB).length > 0) {
          Object.values(dataRAB).forEach((category) => {
            category.forEach((itemRab) => {
              if (itemRab.isSelected) {
                cps.push(itemRab.id);
              }
            });
          });
        }

        const updateCivilOpname = {
          id: item.id,
          clientId: item.clientId,
          companyId: item.companyId,
          branchId: item.branchId,
          blockId: item?.cvlop_product?.product_block?.id,
          productId: item?.cvlop_product?.id,
          description: "",
          files: [],
          checked_progress: cps.length > 0 ? cps.join(",") : "no",
        };
        dispatch(onUpdateCivilOpname(updateCivilOpname));

      }
    }
  };

  document.title = "Opname Pekerjaan | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={civilOpname && civilOpname.contract_employee ? civilOpname.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveComponent} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCivilOpname} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteCivilOpname} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Teknik" pageTitle="Opname Pekerjaan">
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCivilOpname") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={civilOpnamesDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col sm={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0 pb-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("1", "all");
                      }}
                      href="#"
                    >
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA PROGRES
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("2", "DRAFT");
                      }}
                      href="#"
                    >
                      <i className="ri-information-line me-1 align-bottom fs-14"></i>
                      DRAFT
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("3", "ACTIVE");
                      }}
                      href="#"
                    >
                      <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>
                      ACTIVE
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("4", "INACTIVE");
                      }}
                      href="#"
                    >
                      <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>
                      INACTIVE
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row>
                  <CardBody className="mb-0 pb-2">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={5}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`${count} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <Select
                            name="searchblock"
                            value={searchBlock}
                            placeholder="Blok"
                            onChange={(e) => {
                              setSearchBlock(e);
                              toggleBlock(e.value === "" ? "" : `[${e.value}]`);
                            }}
                            options={blockList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col sm={5} style={{ position: "relative" }}>
            <Card style={{ position: "sticky", top: "94px" }}>
              <CardBody className="pt-3">
                <div>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-info">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Opname Pekerjaan" : "Tambah Opname Pekerjaan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                dispatch(setClientSelect(e));
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                            {validation.touched.client && validation.errors.client && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.client}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                setBranchList([]);
                                validation.resetForm();
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                            {validation.touched.company && validation.errors.company && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.company}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="branch-field" className="form-label">
                              Proyek / Cabang&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Pilih Proyek / Cabang"
                              onChange={(e) => {
                                validation.setFieldValue("block", "");
                                validation.setFieldValue("product", "");
                                validation.setFieldValue("branch", e);
                              }}
                              options={branchList}
                            ></Select>
                            {validation.touched.branch && validation.errors.branch && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.branch}
                              </small>
                            )}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="block-field" className="form-label">
                              Blok&nbsp;
                              {productBlockLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="block"
                              value={validation.values.block}
                              placeholder="Pilih Blok"
                              onChange={(e) => {
                                setProductList([]);
                                validation.setFieldValue("product", "");
                                validation.setFieldValue("block", e);
                                handleGetProduct(validation.values.branch.value, e.value);
                              }}
                              options={blockList}
                            ></Select>

                            {validation.touched.block && validation.errors.block && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.block}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="product-field" className="form-label">
                              Produk&nbsp;
                              {productLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="product"
                              value={validation.values.product}
                              placeholder="Pilih Produk"
                              onChange={(e) => {
                                validation.setFieldValue("product", e);
                              }}
                              options={productList}
                            ></Select>
                            {validation.touched.product && validation.errors.product && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.product}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col sm={7} style={{ position: "relative" }}>
            <Card style={{ position: "sticky", top: "94px" }}>
              <div className="card-body mb-0 pb-0 d-flex align-items-center">
                <div className="mb-0 flex-grow-1">
                  <h4>{info && info.cvlop_branch && info.cvlop_branch.name ? info.cvlop_branch.name : ""}</h4>
                  <p className="fs-15 text-uppercase">{info && info.cvlop_product && info.cvlop_product.product_block ? info.cvlop_product.product_category.name + " " + info.cvlop_product.product_block.name + "-" + info.cvlop_product.name : ""}</p>
                </div>
              </div>

              <div className="card-body pt-0 pb-0">
                <div className="mb-3 ">
                  {(civilOpnameList || []).filter(f => f.isChecked).length ? <div className="mb-1">Unit Terpilih :</div> : ""}
                  {(civilOpnameList || []).filter(f => f.isChecked).sort((a, b) => a.sort_order - b.sort_order).map((item, idx) => {
                    return (
                      <span key={idx} className="badge text-uppercase fs-12 badge-soft-info me-1 mb-2">
                        {item?.cvlop_product?.product_block?.name} - {item?.cvlop_product?.name}
                      </span>
                    );
                  })}
                </div>
              </div>
              <div className="card-body border-top">
                {Object.entries(dataRAB).map(([name, items], i) => {
                  return (
                    <div key={i} className={"mb-3"}>
                      <p className="fw-semibold fs-14 text-uppercase m-1">{name}</p>
                      <div className={"pe-3 ps-3 row"}>
                        {(items.sort((a, b) => a.sort_order - b.sort_order) || []).map((item, idx) => {
                          return (
                            <div key={idx} className={"mb-1 form-check form-switch form-switch-custom form-switch-success col-lg-6"}>
                              <Input
                                className={"form-check-input checked-all checked-method-all check-" + item.id + idx}
                                type="checkbox"
                                role="switch"
                                id={"check-" + item.id + idx}
                                value={item.id}
                                checked={!!item.isSelected}
                                //disabled={item.isDisabled}
                                onChange={(e) => {
                                  setDataRAB((prevData) => ({
                                    ...prevData,
                                    [name]: prevData[name].map((itm, indx) => (indx === idx ? { ...itm, isSelected: !itm.isSelected } : itm)),
                                  }));
                                }}
                              />
                              <Label className="form-check-label fs-12 text-uppercase" htmlFor={"check-" + item.id + idx}>
                                {item.name}
                              </Label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
                <div className="mb-3">
                  <Input
                    type="textarea"
                    className="form-control"
                    id="description"
                    placeholder="Keterangan (Jika Ada)"
                    name="description"
                    rows={3}
                    value={validationDetail.values.description ?? ""}
                    onBlur={validationDetail.handleBlur}
                    onChange={(e) => {
                      validationDetail.setFieldValue("description", e.target.value);
                    }}
                    invalid={validationDetail.touched.description && validationDetail.errors.description ? true : false}
                  />
                </div>
                {info &&
                  info.cvlop_file &&
                  info.cvlop_file.length > 0 &&
                  info.cvlop_file.map((f, i) => {
                    if (f.isDeleted) {
                      return null;
                    } else {
                      return (
                        <div key={i} className="border-bottom mb-3">
                          <div className="d-flex justify-content-between mb-3 align-items-center">
                            <div className="me-2">
                              <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                            </div>
                            <div className="text-truncate">{f.originalname}</div>
                          </div>
                        </div>
                      );
                    }
                  })}

                <div className="mb-3 d-flex">
                  <button
                    type="button"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-success add-btn me-2" : userRole && userRole.split(",").indexOf("createCivilProgression") !== -1 ? "btn btn-success add-btn" : "btn btn-success add-btn d-none"}
                    id="create-btn"
                    onClick={() => {
                      validationDetail.handleSubmit();
                    }}
                  >
                    <span className="d-flex align-items-center">
                      SIMPAN PROGRESS {info && info.cvlop_product && info.cvlop_product.product_block ? info.cvlop_product.product_block.name + "-" + info.cvlop_product.name : ""}&nbsp;
                      {loading && (
                        <Spinner size="sm" className="flex-shrink-0" role="status">
                          Loading...
                        </Spinner>
                      )}
                    </span>
                  </button>

                  {(civilOpnameList || []).filter(f => f.isChecked).length ? <button
                    type="button"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-info add-btn" : userRole && userRole.split(",").indexOf("createCivilProgression") !== -1 ? "btn btn-info add-btn" : "btn btn-info add-btn d-none"}
                    id="create-btn"
                    onClick={() => {
                      approveFinalMultiple();
                    }}
                  >
                    <span className="d-flex align-items-center">
                      SIMPAN PROGRESS SEMUA UNIT TERPILIH {(civilOpnameList || []).filter(f => f.isChecked).length + " UNIT"} &nbsp;
                      {loading && (
                        <Spinner size="sm" className="flex-shrink-0" role="status">
                          Loading...
                        </Spinner>
                      )}
                    </span>
                  </button> : ""}

                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CivilOpname;
